import { render, staticRenderFns } from "./Awarded.vue?vue&type=template&id=1016866e&scoped=true&"
import script from "./Awarded.vue?vue&type=script&lang=js&"
export * from "./Awarded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1016866e",
  null
  
)

export default component.exports